/**
 * App shell: the original layout — fullscreen navy/gold background (app-bg),
 * scrollable content with bottom-nav padding (page-content), and the client
 * BottomNav. Screens render their own PageHeader.
 */

import { Outlet } from 'react-router';
import { BottomNav } from './BottomNav';

export default function AppShell() {
  return (
    <div className="page-content app-bg">
      <div style={{ width: '100%', maxWidth: 430, margin: '0 auto', minWidth: 0, overflowX: 'hidden' }}>
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}
